import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditNames extends Component {

    state = {
        name: this.props.name,
        altNames: this.props.altNames.join(', ')
    }

    onSave = () => {
        const { name = '', altNames = '' } = this.state
        if (name.trim() !== '') {
            this.props.onSave({ name, altNames })
        }
    }

    render() {
        const { name = '', altNames = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditNames"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Name / Alt. names">
            <Form>
                <div>
                    <label>Name</label>
                    <input
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Primary name"
                        value={name}
                        onChange={e => this.setState({ name: e.target.value })} />
                </div>
                <div>
                    <label>Alt names</label>
                    <input
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Alternative names"
                        value={altNames}
                        onChange={e => this.setState({ altNames: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditNames



// WEBPACK FOOTER //
// ./src/components/LBUs/EditNames.js